import React from 'react';
import { FileText, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const RegistreSSI = () => {
  const navigate = useNavigate();

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center gap-4">
        <button
          onClick={() => navigate('/dashboard/ssi')}
          className="p-2 hover:bg-gray-100 rounded-lg"
        >
          <ArrowLeft className="h-6 w-6" />
        </button>
        <div>
          <h1 className="text-3xl font-bold text-gray-900 flex items-center gap-3">
            <FileText className="h-8 w-8 text-green-600" />
            Registre de Sécurité Incendie
          </h1>
          <p className="text-gray-600 mt-1">Événements, exercices d'évacuation, visites commission</p>
        </div>
      </div>

      <div className="bg-green-50 border border-green-200 rounded-lg p-8 text-center">
        <FileText className="h-16 w-16 mx-auto mb-4 text-green-500" />
        <h2 className="text-2xl font-bold text-green-900 mb-2">Registre de Sécurité (Obligatoire ERP/IGH)</h2>
        <p className="text-green-700 mb-4">
          Enregistrement officiel de tous les événements liés à la sécurité incendie
        </p>
        <div className="text-sm text-green-600 space-y-2">
          <p>✅ Exercices d'évacuation (2 par an minimum)</p>
          <p>✅ Vérifications périodiques des systèmes</p>
          <p>✅ Visites de la commission de sécurité</p>
          <p>✅ Incidents et travaux de sécurité</p>
          <p>✅ Export PDF conforme réglementation</p>
        </div>
      </div>
    </div>
  );
};

export default RegistreSSI;
